var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 268,
    viewBox: "0 0 281 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38884 132.423L-0.00256348 132.586L2.47004 153.749L3.86144 153.586L1.38884 132.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76982 161.447L3.37842 161.609L4.62588 172.286L6.01728 172.123L4.76982 161.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6979 89.4233L96.698 89.4235C97.7309 92.3134 99.7109 94.7681 102.316 96.3878C104.921 98.0076 107.997 98.6969 111.043 98.3434L111.044 98.3434L247.409 82.3701C249.974 82.0718 252.553 82.8048 254.579 84.4082C256.605 86.0116 257.912 88.3543 258.213 90.9217L274.378 229.128C274.676 231.696 273.943 234.277 272.341 236.304C270.74 238.332 268.399 239.64 265.834 239.942C265.834 239.942 265.834 239.942 265.834 239.942L30.9809 267.434L30.9807 267.435C29.7103 267.584 28.4229 267.481 27.1922 267.132C25.9615 266.783 24.8116 266.195 23.8082 265.401C22.8048 264.607 21.9677 263.622 21.3447 262.504C20.7218 261.386 20.3252 260.155 20.1776 258.883L20.1776 258.883L1.4992 99.0122L1.49919 99.0121C1.05423 95.2081 2.13707 91.3831 4.50944 88.3782C6.88181 85.3733 10.3494 83.4347 14.1495 82.9886L79.7845 75.3044C79.7846 75.3044 79.7846 75.3044 79.7847 75.3044C83.0275 74.9256 86.3027 75.6589 89.0754 77.3843C91.8481 79.1097 93.9543 81.7254 95.0497 84.8041L95.0498 84.8045L96.6979 89.4233Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.728 19.7352L29.5254 34.5352L49.8977 136.859L124.1 122.059L103.728 19.7352Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2904 136.27L30.1134 34.9277L103.335 20.3234L123.512 121.666L50.2904 136.27Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.448 0.0128368L134.484 10.2773L148.614 113.65L223.577 103.385L209.448 0.0128368Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.041 113.087L135.048 10.7049L209.02 0.576062L223.014 102.958L149.041 113.087Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.73 15.1097L63.354 21.6836L72.403 125.625L147.779 119.051L138.73 15.1097Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8578 125.083L63.8955 22.1383L138.275 15.6513L147.237 118.596L72.8578 125.083Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 35.5L131 30M76.5 47.5L132.5 42M77.5 59.5L133.5 54M79 71.5L135 66",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.57 10.0546L154.996 13.7012L160.016 117.915L235.589 114.269L230.57 10.0546Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.491 117.392L155.52 14.1765L230.094 10.5782L235.066 113.794L160.491 117.392Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.127 92.2097L116.932 87.6871C116.077 84.5593 114.107 81.8532 111.395 80.0802C108.682 78.3072 105.414 77.5902 102.209 78.0647L36.5739 85.7489C32.5919 86.2374 28.9247 88.1628 26.2598 91.1642C23.5948 94.1656 22.1151 98.0368 22.0981 102.052L25.8201 258.555C25.8423 259.844 26.14 261.113 26.6932 262.278C27.2463 263.442 28.0421 264.474 29.027 265.305C30.012 266.136 31.1632 266.746 32.4033 267.095C33.6435 267.443 34.9438 267.522 36.2168 267.325L271.07 239.832C273.797 239.501 276.31 238.187 278.138 236.134C279.966 234.082 280.983 231.433 281 228.684L277.786 93.3919C277.762 92.1023 277.463 90.8327 276.908 89.6684C276.353 88.5041 275.556 87.472 274.57 86.6414C273.584 85.8108 272.432 85.2008 271.191 84.8525C269.95 84.5041 268.649 84.4255 267.376 84.6217L131.01 100.595C128.209 101.016 125.352 100.395 122.978 98.85C120.604 97.3048 118.878 94.9424 118.127 92.2097Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 54L222.5 52",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 42L221.5 40",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 30L221.5 28",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 65.5L222.5 63.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 77.5L222.5 75.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 51.5L65.5 47.5M47.5 62L66.5 58.5M49.5 72L67.5 68.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.127 92.2097L116.932 87.6871C116.077 84.5593 114.107 81.8532 111.395 80.0802C108.682 78.3072 105.414 77.5902 102.209 78.0647L36.5739 85.7489C32.5919 86.2374 28.9247 88.1628 26.2598 91.1642C23.5948 94.1656 22.1151 98.0368 22.0981 102.052L25.8201 258.555C25.8423 259.844 26.14 261.113 26.6932 262.278C27.2463 263.442 28.0421 264.474 29.027 265.305C30.012 266.136 31.1632 266.746 32.4033 267.095C33.6435 267.443 34.9438 267.522 36.2168 267.325L271.07 239.832C273.797 239.501 276.31 238.187 278.138 236.134C279.966 234.082 280.983 231.433 281 228.684L277.786 93.3919C277.762 92.1023 277.463 90.8327 276.908 89.6684C276.353 88.5041 275.556 87.472 274.57 86.6414C273.584 85.8108 272.432 85.2008 271.191 84.8525C269.95 84.5041 268.649 84.4255 267.376 84.6217L131.01 100.595C128.209 101.016 125.352 100.395 122.978 98.85C120.604 97.3048 118.878 94.9424 118.127 92.2097Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 268,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeDocs);
export default __webpack_public_path__ + "static/media/welcome-docs.feafe11ec6f822b51d32fd33d562c23f.svg";
export { ForwardRef as ReactComponent };